import { Sentry } from 'lib-shared-sentry';

type ElevioFeature = 'resolution' | 'feedback' | 'suggestions';

/** Simple wrapper to add a Sentry breadcrumb before throwing an error */
export function ElevioError({
  feature,
  context,
  message,
}: {
  feature: ElevioFeature;
  message: string;
  context: string;
}): Error {
  const errorMessage = `${context}: ${message}`;
  Sentry.addBreadcrumb({
    category: `elevio.${feature}`,
    message: errorMessage,
  });
  return new Error(errorMessage);
}
